<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div
    class="tw-flex tw-justify-between tw-items-center tw-ml-5"
    custom-elements
  >
    <span class="tw-font-medium dark:tw-text-gray-100 tw-text-base"
      >{{ "common.lastUpdateDatetime" | translate }} :
    </span>
    <span
      copyToClipboard
      class="text-navyBlue tw-py-1 rounded tw-text-xl tw-mr-2 tw-font-semibold"
      >{{
        lastUpdateDateTime
          | dateTimeWithSecondConvertor
            : translationService.currentLang() || "fa"
      }}</span
    >
  </div>

  <div
    [class.tw-opacity-0]="!this.timerValue"
    class="tw-w-0 tw-h-[3px] tw-transition-[width] tw-duration-1000"
    [themeColor]="'timer-loading'"
    [style.width]="this.timerValue * 25 + '%'"
    custom-header
  ></div>

  <div *ngIf="!this.timerValue" class="tw-h-[3px] w-full"></div>

  <div class="app-page-content" custom-content>
    <div class="row tw-my-2 tw-mx-2">
      <!-- content -->
      <div class="content-section">
        <div *ngIf="items">
          <!-- items -->
          <div
            class="md:tw-px-5 sm:tw-px-0 tw-pt-2 tw-text-center tw-text-[16px] text-dark tw-grid xl:tw-grid-cols-3 sm:tw-grid-cols-2 tw-grid-cols-1 md:tw-gap-4 tw-gap-2"
          >
            <ng-container
              *ngFor="let item of items; trackBy: trackByFunc; let i = index"
            >
              <div class="tw-mb-12">
                <app-queues-statistics-card
                  [model]="item"
                  [vocabsPath]="tableVocabs"
                ></app-queues-statistics-card>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- loading -->
        <div class="tw-flex-center tw-my-5" *ngIf="pageConfig.loading">
          <div
            class="spinner-border text-navyBlue tw-h-[45px] tw-w-[45px]"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <!-- empty -->
        <ng-container *ngIf="!items?.length && !pageConfig.loading">
          <div class="row">
            <div class="tw-w-full">
              <h3 class="tw-text-center tw-text-gray-500 dark:tw-text-gray-300">
                {{ "common.empty" | translate }}
              </h3>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</app-page-template>
